export default __webpack_public_path__ + "static/media/drawing-desk.375e065f.mp3";